import { Page } from '../Page';
import { useEffect, useState } from 'react';
import useAnalytics from '../webAnalyticsContext';
import { getStandardCustomProperties } from '../webAnalytics';
import { addEventToBuffer } from '../analyticsBuffer';
import { AnalyticsEvent } from '../AnalyticsEvent';
const useAnalyticsPage = (page: Page, properties?: object) => {
  const analytics = useAnalytics();
  const [cachedProperties] = useState(properties);
  useEffect(() => {
    analytics?.page(page.category, page.name, {
      ...cachedProperties,
      ...getStandardCustomProperties(),
    });
    addEventToBuffer(new AnalyticsEvent(`${page.name}`, 'Page'), {
      category: page.category,
      ...properties,
    });
  }, [page, analytics, cachedProperties, properties]);
};

export default useAnalyticsPage;
